module.exports = __webpack_public_path__ + "img/fig03.062d4f0e.jpg";